import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode, FilterService } from "primereact/api";
import CreateAsset from "./CreateAsset";
import { assetFamilyMaster, assetType } from "../types/assetTypes";
import { CustomMessage } from "../const/Spinner";
import { enqueueSnackbar } from "notistack";
import {
  deleteAssetDetails,
  getListOfAssets,
  handleAssetFilter,
} from "../api/Services/assetServices";
import Swal from "sweetalert2";
import { OverlayPanel } from "primereact/overlaypanel";
import { Box, Button, Checkbox, Dialog, FormControlLabel, FormGroup, IconButton, ListItemButton, TextField } from "@mui/material";
import ReusableDataTable from "../Component/DataTable/ReusableDataTablePrime";
import ReusablePrimeButton from "../Component/Buttons/ReusablePrimeButton";
import {
  getAssertColumns,
  getAssertButtonData,
  assertBodyTableIcon,
  getAssetSearchAndExportData,
} from "../const/AssertData";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../store/CommonSlice";
import { getFamilyAssetMasterDataList } from "../api/Services/masterServie";
import * as XLSX from "xlsx";
import "xlsx-color";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND } from "../api/endpoint";
import { transformAssetsForExport } from "../utils/exportTransformers";
import { DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ImagePreview from "../Component/ImagePreview";
import { RootState } from "../store/Reduxstore";
import { Popover, List, ListItem, ListItemText, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { InputText } from "primereact/inputtext";




type AssetItem = {
  id: number;
  name: string;
};

type AssetColumnData = {
  [key: string]: AssetItem[];
};
FilterService.register("custom_activity", (value, filters) => {
  const [from, to] = filters ?? [null, null];
  if (from === null && to === null) return true;
  if (from !== null && to === null) return from <= value;
  if (from === null && to !== null) return value <= to;
  return from <= value && value <= to;
});
const AssetInventory: React.FC = () => {
  const dt = useRef<DataTable<any[]>>(null);
  const overlayPanelRef = useRef<OverlayPanel>(null);
  const dispatch = useDispatch();
  const assetOverlayPanelRef = useRef(null);
  const nestedOverlayPanelRef = useRef<OverlayPanel>(null);
  const [products, setProducts] = useState<assetType[]>([]);
  const [open, setOpen] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [assetId, setAssetId] = useState<number | null>(null);
  const [selectedValue, setSelectedValue] = useState<number | null>(null);
  const [userId, setUserId] = useState<number>(0);
  const [overlaySearch, setOverlaySearch] = useState("");


  const [dialogMessage, setDialogMessage] = useState('');

  const [paginationData, setPaginationData] = useState<{
    page: number;
    rows: number;
    totalRecords: number;
  }>({
    page: 1,
    rows: 13,
    totalRecords: 0,
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [familyAsset, setFamilyAsset] = useState<assetFamilyMaster[]>([]);


  useEffect(() => {
    if (familyAsset.length === 0) getFamilyAssetList(1, PAGESEND);
  }, [familyAsset]);

  const [assetColumnData, setAssetColumnData] = useState<AssetColumnData>({});
  const [selectedKeyData, setSelectedKeyData] = useState<AssetItem[]>([]);

  const [nestedPanelPosition, setNestedPanelPosition] = useState<React.MouseEvent | null>(null);
  useEffect(() => {
    if (Object.keys(assetColumnData).length === 0) {
      getAssetColumnList();
    }
  }, [assetColumnData]); // re-run if assetColumnData changes

  const getAssetColumnList = async () => {
    dispatch(setLoading(true));
    try {
      // explicitly tell TS what shape to expect
      const { data, status } = await handleAssetFilter()

      if (status.code === 200 && typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length > 0) {
        // now TS knows data is an object, not an array
        setAssetColumnData(data);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  type AssetItem = {
    id: number;
    name: string;
  };
  // const [searchText, setSearchText] = useState("");
  type AssetColumnData = {
    [key: string]: AssetItem[];
  };
  // const [filters, setFilters] = useState<Filters>({});
  const [filters, setFilters] = useState<Filters>({});
  useEffect(() => {
    console.log("Filters updated:", filters);
  }, [filters]);
  const [tempFilters, setTempFilters] = useState<Filters>({}); // ✨ temporary filters
  const [filterCol, setFilterCol] = useState<string>('');
  // const [checkedValues, setCheckedValues] = useState<string[]>([]);
  const [searchText, setSearchText] = useState('');
  useEffect(() => {
    console.log("Updated filterCol inside useEffect:", filterCol);
  }, [filterCol]);


  const [columnData, setColumnData] = useState<AssetColumnData>({});
  const currentColValues = (columnData[filterCol] || []).map((item: { name: string }) => item.name);
  const filteredValues = currentColValues.filter((val: string) =>
    val.toLowerCase().includes(searchText.toLowerCase())
  );



  const handleSubmit = (newFilters: Filters) => {
    console.log("Submitted Filters:", newFilters);
    setFilterData(newFilters);
    onFetchData(paginationData.page, paginationData.rows, newFilters);
    closeSubPopover();
    closeVisibilityPopover();
  };



  const handleCancel = () => {
    // setCheckedValues([]);  // ✅ Only clear the current checkbox selections
    closeSubPopover();     // ✅ Close the popover
  };

  const openVisibilityPopover = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget); // Anchor the popover

    // Fetch asset column data on click
    dispatch(setLoading(true));

    try {
      const response = await handleAssetFilter(); // Get the full response

      console.log("API Response:", response); // Log the full response

      // Check if the response is valid and contains the 'data' object
      if (response && response.status && response.status.code === 200 && response.data) {
        const data = response.data;

        setColumnData(data); // Store the full data, if needed for later

        // Map through each key in the response's data object
        const formattedCols = Object.keys(data).map((key) => ({
          key,
          label: key.replace(/_/g, " "), // Make the key more readable by replacing underscores with spaces
          values: data[key].map((item: { name: string }) => item.name), // Access the 'name' property of each object
        }));

        console.log("Formatted Columns:", formattedCols); // Log formatted columns for debugging
        setColumns(formattedCols); // Store formatted columns in state
      } else {
        // If response does not contain valid data, show an error message
        CustomMessage("Failed to fetch valid data", "error", enqueueSnackbar); // Custom error message
      }
    } catch (error: any) {
      // Handle any errors and display custom error messages
      CustomMessage(error.message, "error", enqueueSnackbar); // Custom error message on failure
    } finally {
      // Stop the loading indicator when the request completes (success or error)
      dispatch(setLoading(false));
    }
  };

  type FilterValue = {

    value: string[];
  };

  type Filters = {
    [key: string]: FilterValue;
  };




  const getFamilyAssetList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getFamilyAssetMasterDataList(page, rows, { familyAssetId: { value: "", matchMode: "startWith" } });
      if (status.code === 200 && data?.length > 0) {
        setFamilyAsset(data);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const actionBodyTemplate = (rowData: assetType) => {
    const renderIconData = assertBodyTableIcon(
      handleEditAsset,
      handleDeleteAsset,
      rowData
    );
    return (
      <>
        {renderIconData &&
          renderIconData.map((val, index) => (
            <ReusablePrimeButton key={index} {...val} />
          ))}
      </>
    );
  };



  const ImageRendering = (rowData: assetType) => {
    const attachmentId = rowData.attachment?.attachmentId || 0; // Fallback image

    return (
      <div className="flex align-items-center gap-2">
        {
          (attachmentId !== 0 && attachmentId != null) && (
            <ImagePreview
              src={`${FILE_DOWNLOAD_PREVIEW + attachmentId}`}
              alt={`Attachment ${attachmentId}`}
              style={{
                width: "19px",
                height: "19px",
                borderRadius: "50%",
                objectFit: "cover"
              }}
            />


          )
        }
      </div>
    );
  };

  const ImageRendering1 = (rowData: assetType) => {
    const attachmentId = rowData.capexAttachmentId || 0; // Fallback image

    return (
      <div className="flex align-items-center gap-2">
        {
          (attachmentId !== 0 && attachmentId != null) && (
            <ImagePreview
              src={`${FILE_DOWNLOAD_PREVIEW + attachmentId}`}
              alt={`Attachment ${attachmentId}`}
              style={{
                width: "19px",
                height: "19px",
                borderRadius: "50%",
                objectFit: "cover"
              }}
            />


          )
        }
      </div>
    );
  };

  const ImageRendering2 = (rowData: assetType) => {
    const attachmentId = rowData.logisticsAttachmentId || 0; // Fallback image

    return (
      <div className="flex align-items-center gap-2">
        {
          (attachmentId !== 0 && attachmentId != null) && (
            <ImagePreview
              src={`${FILE_DOWNLOAD_PREVIEW + attachmentId}`}
              alt={`Attachment ${attachmentId}`}
              style={{
                width: "19px",
                height: "19px",
                borderRadius: "50%",
                objectFit: "cover"
              }}
            />


          )
        }
      </div>
    );
  };



  const columns = getAssertColumns(actionBodyTemplate, ImageRendering, ImageRendering1, ImageRendering2);

  const [filterData, setFilterData] = useState<Filters>(
    // () =>
    //       (columns ?? []).reduce((acc, col) => {
    //         if (col.field) {
    //           acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
    //         }
    //         return acc;
    //       }, {} as Record<string, { value: string; matchMode: string }>),
  );

  const handleSelect = (value: number) => {
    setSelectedValue(value);
    overlayPanelRef.current?.hide(); // Close the overlay panel after selection
    setOpen(true);
  };

  const onGlobalFilterChange = (e: { target: { value: any } }) => {
    console.log(e.target)

  };

  const formatDate = (date: string) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB"); // DD/MM/YYYY
  };

  const exportCSV = async (selectionOnly: boolean) => {
    let dataToExport: any[] = [];

    if (selectionOnly) {
      if (!selectedProducts || selectedProducts.length === 0) {
        alert("No rows selected for export.");
        return;
      }
      dataToExport = selectedProducts;
    } else {
      dispatch(setLoading(true));
      try {
        const response = await getListOfAssets(1, 10000, filterData);

        if (response.status.code === 200 && response.data) {
          dataToExport = response.data;
        } else {
          CustomMessage("Failed to fetch data for export.", "error", enqueueSnackbar);
          return;
        }
      } catch (error: any) {
        CustomMessage(error.message, "error", enqueueSnackbar);
        return;
      } finally {
        dispatch(setLoading(false));
      }
    }

    // 🔹 FORMAT DATA
    const rows = dataToExport.map((item, index) => ({
      "S.No": index + 1,

      "Asset ID": item.assetId,
      "Asset Name": item.assetName,
      "Harmony Code": item.harmonyCode,
      "Harmony Name": item.harmonyName || "-",
      "Local Code": item.localCode,
      "Serial No": item.srNo,

      "Asset Owner": item.assetOwnerName,
      "Family Asset": item.familyAssetName,
      "Class Code": item.classCode,
      "Class Description": item.classCodeDes,
      "Type Code": item.typeCode || "-",
      "Type Description": item.typeCodeDes || "-",

      "Region": item.regionName,
      "Country": item.countryName,
      "Project": item.projectName || "-",

      "Manufacturer": item.manufacturerName,
      "Model": item.modelName,
      "COO": item.coo,

      "Manufacture Date": formatDate(item.manufacturerDate),
      "Purchase Date": formatDate(item.purchaseDate),

      "Length": item.length,
      "Width": item.width,
      "Height": item.height,
      "Weight": item.weight,

      "Purchase Value": item.purchaseValue,
      "Insurance Value": item.insuranceValue,
      "Currency": item.insuranceCurrency,

      "Contract Type": item.contractType,
      "Internal/External": item.intext,
      "Tool/Equipment": item.toolequip,

      "No Charge": item.noCharge,
      "Half Shift Charge": item.halfShiftCharge,
      "Full Shift Charge": item.fullShiftCharge,
      "Double Shift Charge": item.doubleShiftCharge,
      "Operator Rate 1": item.rateop1,
      "Operator Rate 2": item.rateop2,

      "Optional 1": item.optional1,
      "Optional 2": item.optional2,
      "Optional 3": item.optional3,
      "Optional 4": item.optional4,
      "Optional 5": item.optional5,
      "Optional 6": item.optional6,
      "Optional 7": item.optional7,
      "Optional 8": item.optional8,

      "Tech Additional": item.techAdditional,
      "Techniques": item.techniqueNames?.join(", ") || "-",

      "Comments": item.comments,
      "HS Code": item.hsCode,
      "Capex Ref": item.capexFormRef,
      "Group Code": item.groupCode,
      "Global Code": item.globalCode,

      // 🔥 3 IMAGE COLUMNS
      "Asset Image": item.imageAttachmentId
        ? "Download Image"
        : "No Image",
      "Capex Image": item.capexAttachmentId ? "Download Image" : "No Image",
      "Logistics Image": item.logisticsAttachmentId ? "Download Image" : "No Image",
    }));

    // 🔹 CREATE SHEET
    const worksheet = XLSX.utils.json_to_sheet(rows);

    const range = XLSX.utils.decode_range(worksheet["!ref"] || "");
    const keys = Object.keys(rows[0]);

    const assetCol = keys.indexOf("Asset Image");
    const capexCol = keys.indexOf("Capex Image");
    const logisticsCol = keys.indexOf("Logistics Image");

    // 🔥 APPLY HYPERLINKS
    // 🔥 APPLY HYPERLINKS
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const original = dataToExport[R - 1];

      const applyLink = (colIndex: number, id: any) => {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: colIndex });

        if (
          worksheet[cellAddress] &&
          worksheet[cellAddress].v === "Download Image" &&
          id
        ) {
          const url = `${FILE_DOWNLOAD_PREVIEW}${id}`;

          worksheet[cellAddress] = {
            t: "s",
            v: "Download Image",
            l: {
              Target: url,
              Tooltip: "Click to download image",
            },
            s: {
              font: {
                color: { rgb: "0000FF" },
                underline: true,
              },
            },
          };
        }
      };

      // ✅ FIXED FIELD NAME
      applyLink(assetCol, original?.imageAttachmentId);

      applyLink(capexCol, original?.capexAttachmentId);
      applyLink(logisticsCol, original?.logisticsAttachmentId);
    }

    // 🔹 EXPORT
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");

    XLSX.writeFile(workbook, "Asset_Data.xlsx");
  };




  const exportToExcel = (data: any[]) => {
    const worksheet = XLSX.utils.json_to_sheet(data);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");

    // ✅ THIS LINE IS IMPORTANT
    XLSX.writeFile(workbook, "Asset_Data.xlsx");
  };
  const handleDeleteAll = (selectionOnly: assetType[]) => {
    if (selectionOnly.length === 0) {
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this all!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        selectionOnly.map(async (val) => {
          try {
            dispatch(setLoading(true));
            const response = await deleteAssetDetails(val?.assetId);
            if (response.status === 200) {
              onFetchData(paginationData.page, paginationData.rows, filterData);
              CustomMessage("Data deleted", "success", enqueueSnackbar);
            } else {
              CustomMessage(
                "Failed to delete the asset.",
                "error",
                enqueueSnackbar
              );
            }
          } catch (error: any) {
            CustomMessage(error?.message, 'error', enqueueSnackbar);
          } finally {
            dispatch(setLoading(false));
          }
        })
      }
    });
  }
  const handleClearFilter = () => {
    // Clear filters and related UI states
    setFilterData({});
    setTempFilters({});
    setFilters({});
    setSelectedValues([]);
    setFilterCol("");
    setSearchText("");
    setSubAnchorEl(null); // Close second popover if open
    setAnchorEl(null);    // Close first popover if open

    // Refetch data without any filters
    onFetchData(paginationData.page, paginationData.rows, {});
  };



  //  const handleClearFilter = () => {


  //   setFilterData(updatedFilter); // Update the filter state
  //   setSearchText("");

  //   onFetchData(paginationData.page, paginationData.rows, updatedFilterData);
  // };



  // Close the dialog
  const handleClose = () => {
    setOpen(false);
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [subAnchorEl, setSubAnchorEl] = useState<null | HTMLElement>(null);

  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  type Column = {
    key: string;
    label: string;
    values?: string[];
  };

  const openSubPopover = (
    event: React.MouseEvent<HTMLElement>,
    col: Column
  ) => {
    setSubAnchorEl(event.currentTarget);
    setFilterCol(col.key);
    setSelectedValues(col.values || []);
  };



  const closeSubPopover = () => {
    setSubAnchorEl(null);

  };
  const [columnns, setColumns] = useState<{ key: string; label: string }[]>([]);

  const closeVisibilityPopover = () => {
    setAnchorEl(null);
    // setCheckedValues([]); // clear selections
    setSearchText(''); // clear search input
  };

  type FilterState = {
    [key: string]: {
      value: string[];
    };
  };

  const userDetails = useSelector((state: RootState) => state.auth);



  // Generate button data dynamically
  const buttonData = getAssertButtonData(
    // /initFilters,

    handleClearFilter,
    overlayPanelRef,
    selectedProducts,
    handleDeleteAll,
    openVisibilityPopover, { role: userDetails.role.map(r => r.roleName) }
  );

  const { inputField, headerButtons } = getAssetSearchAndExportData(
    globalFilterValue,
    onGlobalFilterChange,
    exportCSV
  );

  const handleSearch = () => {
    onFetchData(PAGESTART, PAGESEND, {}, searchText); // Call with search text
  };

  const [search, setSearch] = useState("");

  const filteredItems = familyAsset.filter((item) =>
    item.familyName.toLowerCase().includes(search.toLowerCase())
  );

  const renderHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px",
          gap: "16px",
          width: "100%",
        }}
      >
        {/* Icons (Buttons) and Search Box in the Same Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Left Side - Buttons */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {buttonData &&
              buttonData.map((val) => <ReusablePrimeButton key={val.label} {...val} />)}
            {headerButtons &&
              headerButtons.map((btn, index) => <ReusablePrimeButton key={index} {...btn} />)}
          </div>

          <OverlayPanel
            ref={overlayPanelRef}
            className="w-48 sm:w-64 h-100px overflow-y-auto mt-[20px]"
            onHide={() => setOverlaySearch("")} // reset search when panel closes
          >
            <div className="mb-2">
              <InputText
                value={overlaySearch}
                onChange={(e) => setOverlaySearch(e.target.value)}
                placeholder="Search..."
                className="w-full p-inputtext-sm"
              />
            </div>

            <ul className="list-none p-0 m-0 max-h-64 overflow-y-auto">
              {familyAsset
                .filter((val) =>
                  val.familyName.toLowerCase().includes(overlaySearch.toLowerCase())
                )
                .map((val) => (
                  <li key={val.familyAssetId} className="py-1">
                    <ReusablePrimeButton
                      label={val.familyName}
                      onClick={() => handleSelect(val.familyAssetId)}
                      className="p-button-text w-full text-left px-3 py-1"
                    />
                  </li>
                ))}
            </ul>
          </OverlayPanel>


          {/* <OverlayPanel ref={overlayPanelRef} className="w-48 sm:w-64 h-100px overflow-y-auto">
              <ul className="list-none p-0 m-0">
                {familyAsset.map((val) => (
                  <li key={val.familyAssetId} className="py-1">
                    <ReusablePrimeButton
                      label={val.familyName}
                      onClick={() => handleSelect(val.familyAssetId)}
                      className="p-button-text w-full text-left px-3 py-1"
                    />
                  </li>
                ))}
              </ul>
              </OverlayPanel>  */}
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={() => setOpen(false)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            PaperProps={{
              sx: {
                p: 1,
                width: 250,
                borderRadius: 2,
                boxShadow: 4,
              },
            }}
          >
            <TextField
              size="small"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              fullWidth
              sx={{ mb: 1 }}
            />
            <List sx={{ maxHeight: 200, overflowY: "auto" }}>
              {filteredItems.length > 0 ? (
                filteredItems.map((item, index) => (
                  <ListItem key={index} disablePadding>
                    <ListItemButton>
                      <ListItemText
                        onClick={() => handleSelect(item.familyAssetId)}
                        primary={item.familyName}
                        primaryTypographyProps={{ fontWeight: "bold" }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))
              ) : (
                <ListItem>
                  <ListItemText primary="No results found" />
                </ListItem>
              )}
            </List>
          </Popover>
          <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <IconButton onClick={openVisibilityPopover}>
            </IconButton>
          </Box>

          <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={closeVisibilityPopover}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <FormGroup sx={{ p: 2, minWidth: 220 }}>
              {columnns.map((col) => (
                <Box
                  key={col.key}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    px: 1,
                    py: 0.5,
                    '&:hover': { backgroundColor: '#f5f5f5', borderRadius: 1 },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFilterCol(col.key);

                    const currentChecked =
                      tempFilters[col.key]?.value || filters[col.key]?.value || [];
                    // setCheckedValues(currentChecked);

                    openSubPopover(e, col);
                  }}
                >
                  <Typography variant="body2">{col.label}</Typography>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setFilterCol(col.key);

                      const currentChecked =
                        tempFilters[col.key]?.value || filters[col.key]?.value || [];
                      // setCheckedValues(currentChecked);

                      openSubPopover(e, col); // Pass the full Column object here
                    }}

                  >
                    <FilterListIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </FormGroup>
          </Popover>


          <Popover
            open={!!subAnchorEl}
            anchorEl={subAnchorEl}
            onClose={closeSubPopover}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            transformOrigin={{ vertical: 'center', horizontal: 'left' }}
          >
            <Box sx={{ p: 2, width: 250 }}>
              <Typography variant="body2" gutterBottom>
                Filter by {filterCol.replace(/_/g, ' ')}
              </Typography>

              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder={`Search ${filterCol}`}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ mt: 1 }}
              />

              <Box sx={{ mt: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={
                        filteredValues.length > 0 &&
                        filteredValues.every((value) =>
                          tempFilters[filterCol]?.value?.includes(value)
                          // ||
                          //   checkedValues.includes(value)
                        )
                      }
                      onChange={(e) => {
                        const currentValues = Array.isArray(tempFilters[filterCol]?.value)
                          ? tempFilters[filterCol].value
                          : [];

                        const newChecked = e.target.checked
                          ? Array.from(new Set([...currentValues, ...filteredValues]))
                          : currentValues.filter((v) => !filteredValues.includes(v));

                        setTempFilters((prev) => ({
                          ...prev,
                          [filterCol]: { value: newChecked },
                        }));



                        setTempFilters((prev) => ({
                          ...prev,
                          [filterCol]: { value: newChecked },
                        }));
                      }}
                    />
                  }
                  label={<Typography variant="body2">Select All</Typography>}
                />
              </Box>

              <Box sx={{ mt: 1 }}>
                {filteredValues.map((value, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        size="small"
                        checked={
                          tempFilters[filterCol]?.value?.includes(value)
                          // ||
                          // checkedValues
                          // .includes(value)
                        }
                        // onChange={(e) => {
                        //   const isChecked = e.target.checked;
                        //   const current = tempFilters[filterCol]?.value;
                        //   // || checkedValues

                        //   const updated = isChecked
                        //     ? [...current, value]
                        //     : current.filter((v) => v !== value);
                        //   setTempFilters((prev) => ({
                        //     ...prev,
                        //     [filterCol]: { value: updated },
                        //   }));
                        // }}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          const current = tempFilters[filterCol]?.value || []; // Ensure current is always an array

                          const updated = isChecked
                            ? [...current, value] // Add value if checked
                            : current.filter((v) => v !== value); // Remove value if unchecked

                          setTempFilters((prev) => ({
                            ...prev,
                            [filterCol]: { value: updated },
                          }));
                        }}
                      />
                    }
                    label={<Typography variant="body2">{value}</Typography>}
                  />
                ))}
              </Box>

              <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                <Button variant="outlined" color="secondary" onClick={handleCancel}>
                  Close
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    const newFilters: Filters = {
                      ...filters,
                      ...tempFilters,
                    };
                    setFilters(newFilters);
                    handleSubmit(newFilters);
                    //  setTempFilters({});
                    // setCheckedValues([]);
                    setSearchText('');
                    closeSubPopover();
                    closeVisibilityPopover();
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Popover>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search..."
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "250px",
              }}
            />
            <button
              onClick={handleSearch}
              style={{
                padding: "8px 12px",
                marginLeft: "8px",
                borderRadius: "4px",
                border: "none",
                backgroundColor: "#007bff", // Keeping the original color
                color: "white",
                cursor: "pointer",
              }}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleEditAsset = (
    assetId: number,
    selectedFamilyAsset: number
  ) => {
    const userId = userDetails?.userId ?? 0;

    setAssetId(assetId);
    setSelectedValue(selectedFamilyAsset);
    setUserId(userId); // ✅ assuming you have a setUserId state hook

    setOpen(true);
  };
  const handleDeleteAsset = async (assetId: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(setLoading(true));
        try {
          const response = await deleteAssetDetails(assetId);
          if (response.status === 200) {
            onFetchData(paginationData.page, paginationData.rows, filterData);
            CustomMessage("Data deleted", "success", enqueueSnackbar);
          } else {
            CustomMessage(
              "Failed to delete the asset.",
              "error",
              enqueueSnackbar
            );
          }
        } catch (error: any) {
          CustomMessage(
            error?.message || "Something went wrong!",
            "error",
            enqueueSnackbar
          );
        } finally {
          dispatch(setLoading(false));
        }
      } else {
        CustomMessage("Deletion cancelled", "info", enqueueSnackbar);
      }
    });
  };

  // Function to fetch data with pagination, global filter, and field filters
  const onFetchData = async (page: number, rows: number, filter?: Filters, searchTerm: string = searchText) => {
    dispatch(setLoading(true));
    try {
      const response = await getListOfAssets(page, rows, filter, searchTerm);
      const { data, status, pagination } = response;

      if (status.code === 200 && data != null && data?.length > 0) {
        console.log("data:", response.pagination);
        setProducts(response.data);
        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,

        });
      } else {
        setProducts([]);
        //CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const header = renderHeader();
  return (
    <div>
      {!open ? (
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 3,
            boxShadow: 3,
            padding: 2, // Add padding for better spacing
          }}
        >


          <ReusableDataTable
            ref={dt}
            data={products}
            columns={columns}
            onFetchData={onFetchData}
            emptyMessage="No data found."
            globalFilterFields={[
              "assetOwnerName",
              "harmonyCode",
              "codeType",
              "familyAsset",
            ]}
            header={header}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            selection={selectedProducts}
            selectionMode={"multiple"}
            filters={filters}
            setFilters={setFilters}
            pagination={paginationData}
            setPagination={setPaginationData}
            onRowDoubleClick={(rowData) => {
              console.log('Double-click row:', rowData);
              handleEditAsset(rowData.assetId, rowData.familyAssetId);
            }}
          />
        </Box>
      ) : (
        <CreateAsset
          setOpen={setOpen}
          assetId={assetId}
          selectedFamilyName={familyAsset.find(val => val.familyAssetId === selectedValue)?.familyName || ""}
          setAssetId={setAssetId}
          userId={userId}
          selectedValue={selectedValue}
          selectedFamily={familyAsset.filter(val => val.familyAssetId === selectedValue)}
          getListOfSelectedProducts={() =>
            onFetchData(paginationData.page, paginationData.rows, filterData)
          }
        />
      )}
    </div>
  );
};

export default AssetInventory;
